import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Button, Grid, Row, Col } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';
import { find as _find } from 'lodash';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { getNameInCurrentLanguage } from 'helpers/intl';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormErrors from 'components/forms/FormErrors';

class LeadChangePipelineForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newPipeline: null,
      newStage: null,
    };
  }

  onSubmit = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const { newPipeline, newStage } = this.state;

    if (newPipeline && newStage) {
      const { lead } = this.props;
      this.props.onSubmit(lead.id ? lead.id : lead.getId(), { newPipeline: newPipeline.id, newStage });
    }
  };

  render() {
    const {
      intl: { messages },
      onSubmitParent,
      formStatus,
      lead,
      intl,
      appIntl,
    } = this.props;
    const { newPipeline, newStage } = this.state;

    const pipelineStages =
      lead.pipeline && lead.pipeline.stages ? lead.pipeline.stages : lead.getPipeline().getStages();
    const currentStageId = lead.current_stage ? lead.current_stage : lead.getCurrentStage();

    const currentStage = _find(pipelineStages, ['id', currentStageId]);

    return (
      <div>
        <FormErrors formStatus={formStatus} />

        <form type="post" onSubmit={this.onSubmit}>
          <div class="panel panel-transparent">
            <Grid fluid>
              <Row>
                <Col xs={12} sm={5}>
                  <div class="p-t-15">
                    <h6 class="font-secondary text-uppercase fs-11 p-b-10 no-margin bold text-master">
                      {messages.current_pipeline}
                    </h6>
                    {getNameInCurrentLanguage(
                      lead.pipeline && lead.pipeline.name ? lead.pipeline.name : lead.getPipeline().getName(),
                      appIntl
                    )}
                  </div>
                </Col>
                <Col xs={12} sm={2}>
                  <div class="text-center p-t-25 p-b-20">
                    <i class="hidden-xs fa fa-angle-double-right" />
                    <i class="hidden-sm hidden-md hidden-lg fa fa-angle-double-down" />
                  </div>
                </Col>
                <Col xs={12} sm={5}>
                  <div class="form-group-attached">
                    <FormAutocomplete
                      autocompleteType="pipeline"
                      name="newPipeline"
                      label="New pipeline"
                      onChange={(name, newPipeline) => this.setState({ newPipeline })}
                      returnValueObject
                    />
                  </div>
                </Col>
              </Row>

              <AnimateHeight duration={500} height={this.state.newPipeline ? 'auto' : 0}>
                <Row>
                  <div class="p-t-15">
                    <Col xs={12} sm={5}>
                      <div class="p-t-15">
                        <h6 class="font-secondary text-uppercase fs-11 p-b-10 no-margin bold text-master">
                          {messages.current_stage}
                        </h6>
                        {getNameInCurrentLanguage(
                          currentStage.name ? currentStage.name : currentStage.getName(),
                          appIntl
                        )}
                      </div>
                    </Col>
                    <Col xs={12} sm={2}>
                      <div class="text-center p-t-25 p-b-20">
                        <i class="hidden-xs fa fa-angle-double-right" />
                        <i class="hidden-sm hidden-md hidden-lg fa fa-angle-double-down" />
                      </div>
                    </Col>
                    <Col xs={12} sm={5}>
                      <div class="form-group-attached">
                        <FormAutocomplete
                          name="newStage"
                          label="New stage"
                          onChange={(name, newStage) => this.setState({ newStage })}
                          options={
                            newPipeline
                              ? newPipeline.stages.map(stage => {
                                  return { label: getNameInCurrentLanguage(stage.name, appIntl), value: stage.id };
                                })
                              : []
                          }
                        />
                      </div>
                    </Col>
                  </div>
                </Row>
              </AnimateHeight>
            </Grid>
          </div>

          <div class="text-right m-t-15">
            <Button
              bsSize="lg"
              disabled={formStatus.pending}
              type="submit"
              bsStyle={newPipeline !== null && newStage !== null ? 'primary' : 'default'}
            >
              <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
              {messages.save}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    formStatus: state.formStatus.leadChangePipeline,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (leadId, args) => {
      formStatusDispatchHelper('leadChangePipeline', '/api/leads/' + leadId + '/pipeline.json', args, 'post', dispatch);
    },
    onFormSuccessfull: () => {
      dispatch(formReset('leadChangePipeline'));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LeadChangePipelineForm)
  )
);
